import React from 'react';
import { useNearScreen } from '../hooks/useNearScreen';

export const withNearScreen = (WrappedComponent) => (props) => {
  const [show, element] = useNearScreen();
  return <WrappedComponent show={show} element={element} {...props} />;
};
